import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Shield, Heart, Activity, Carrot, Sparkles } from 'lucide-react';
const ingredients = [{
  icon: <Leaf className="w-6 h-6 text-forest" data-id="element-113" />,
  title: 'Johannisbrotmehl',
  desc: 'Bindet überschüssige Flüssigkeit im Darm, reguliert den Stuhlgang natürlich.'
}, {
  icon: <Shield className="w-6 h-6 text-forest" data-id="element-114" />,
  title: 'Leinsamen',
  desc: 'Bildet eine schützende Schleimschicht für die gereizte Darmwand.'
}, {
  icon: <Activity className="w-6 h-6 text-forest" data-id="element-115" />,
  title: 'Inulin & Topinambur',
  desc: 'Wertvolle Präbiotika fördern gesunde Darmbakterien nachhaltig.'
}, {
  icon: <Heart className="w-6 h-6 text-forest" data-id="element-116" />,
  title: 'Mariendistel',
  desc: 'Unterstützt aktiv die Leber und den gesamten Verdauungsapparat.'
}, {
  icon: <Carrot className="w-6 h-6 text-forest" data-id="element-117" />,
  title: 'Möhrenmehl',
  desc: 'Reich an Pektin, wirkt natürlich stuhlfestigend und beruhigend.'
}, {
  icon: <Sparkles className="w-6 h-6 text-forest" data-id="element-118" />,
  title: '100% Natürlich',
  desc: 'Rein pflanzlich, keine künstlichen Zusätze, absolut keine Chemie.'
}];
export function ProductExplanation() {
  return <section className="w-full py-16 bg-white/50 border-y border-brown-light/20" data-id="element-119">
      <div className="max-w-5xl mx-auto px-4" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-121">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest mb-4" data-id="element-122">
            Warum es bei Durchfall helfen kann
          </h2>
          <p className="font-serif text-lg text-brown-dark/70 max-w-2xl mx-auto" data-id="element-123">
            Die Kraft der Natur statt chemischer Keule. Jede Zutat hat eine
            spezifische Aufgabe für den Magen-Darm-Trakt.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-dark p-6 rounded-xl border border-brown-light/20 hover:shadow-md transition-shadow" data-id="element-125">
              <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-126">
                {item.icon}
              </div>
              <h3 className="font-serif font-semibold text-xl text-brown-dark mb-2" data-id="element-127">
                {item.title}
              </h3>
              <p className="font-serif text-brown-dark/80 leading-relaxed" data-id="element-128">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}